<template>
  <common-dialog @opened="onOpened" ref="dialog" :title="title" width="1000px" class="examDialog" :in-dialog="inDialog">
    <list ref="list" common :show-checkbox="multiple" :show-query="false" :page="page">
      <template #column>
        <slot name="column" />
        <el-table-column
          label="操作"
          align="center"
          width="60"
          fixed="right"
          v-if="selectable&&!multiple"
        >
          <template slot-scope="{row}">
            <el-button @click="onSelect(row)" type="text">选择</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <template slot="footer">
      <slot name="footer">
        <el-button type="primary" @click="selectMultiple" v-if="selectable&&multiple" size="small">选择</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "./list";
import listDialogMixins from "@/mixins/listDialog";
export default {
  components: { commonDialog, list },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "考试列表"
    },
    page: {
      type: Boolean,
      default: true
    },
    selectExam: {
      type: Array,
      default: () => []
    }
  },
  methods:{
    onOpened(data){
    },
    setSelected() {
      let td = this.$refs.list.$refs.list.data;
      this.selectExam.forEach(e => {
        // console.log("e",e)
        td.forEach(n => {
          if(e.ExamId == n.ExamId || e.EntryExamId == n.ExamId || e == n.ExamId) {
            this.$refs.list.$refs.list.$refs.table.toggleRowSelection(n);
          }
        })
      })
    },
  }
};
</script>
<style>
.examDialog .filter-container{
  display: none;
}
</style>